import { Autocomplete, Chip, TextField } from "@mui/material";
import { Control, Controller, FieldPathByValue, FieldValues } from "react-hook-form";

/**
 * A repeatable, free-text list of waste codes rendered as deletable chips with a
 * free-solo input. Codes are not validated against a reference list here. Used
 * for both the §13 episodic federal/state code lists and the §16 HSM activity
 * codes (any `string[]` field on the form).
 */
export function WasteCodesField<T extends FieldValues>({
  name,
  label,
  disabled,
  control,
}: {
  name: FieldPathByValue<T, string[]>;
  label: string;
  disabled: boolean;
  control: Control<T>;
}) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          multiple
          freeSolo
          // Commit a typed code on blur so clicking the dialog's Save button
          // (which blurs the input) captures it even without pressing Enter.
          autoSelect
          options={[]}
          value={field.value ?? []}
          disabled={disabled}
          onChange={(_, value) => field.onChange(value)}
          renderTags={(value, getTagProps) =>
            value.map((code, index) => {
              const { key, ...chipProps } = getTagProps({ index });
              return <Chip key={key} label={code} size="small" {...chipProps} />;
            })
          }
          renderInput={(params) => <TextField {...params} label={label} />}
        />
      )}
    />
  );
}
